import React from "react";
import {Grid, Button, Typography} from "@material-ui/core";
import { AddCircle, RemoveCircle } from "@material-ui/icons";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import { Mutation } from "react-apollo";
import UPDATE_CHEF from "../../graphql/mutations/chef/update_chef";
import IconButton from "@material-ui/core/IconButton/IconButton";
import style from "./style";
import Fab from "@material-ui/core/Fab/Fab";
import ReactAutocomplete from "react-autocomplete";
import DinerButton from '../../components/DinerButton';
import { NotificationManager } from "react-notifications";
import {primaryColor} from "../../config/theme";

const CuisineSchema = Yup.object().shape({
  cuisines: Yup.array()
});

class Cuisines extends React.Component {
  componentDidMount() {
    window.onload = function() {
      window.scrollTo(0, 0);
    };

    const {list, cuisines} = this.state;
    const indexes = [];
    cuisines.forEach(selectedCuisine => {
      list.forEach((cuisine, index) => {
        if (cuisine.name.toLowerCase() === selectedCuisine.name.toLowerCase()) {
          indexes.push(index);
        }
      });
    });

    if (indexes.length > 0) {
      for (let i=(indexes.length - 1); i>=0; i--) {
        list.splice(indexes[i], 1);
      }
    }

    this.setState({ list });
  }

  constructor(props) {
    super(props);
    this.state = {
      cuisines: props.selected
        ? props.selected.map(item => {
            return { name: item, selected: true };
          })
        : [],
      cuisine: "",
      value: "",
      cuisineToBeRemoved: "",
      list:
        props.cuisines && !!props.cuisines.length
          ? props.cuisines.map(item => {
              return { name: item, selected: false };
            })
          : []
    };
  }

  selectCuisine = (index, value) => {
    let { cuisines } = this.state;
    cuisines = cuisines.map(cuisine => {
      cuisine.selected = true;
      return cuisine;
    })
    cuisines[index].selected = value;
    this.setState({ cuisines }, () => {
      this.removeCuisine();
    });
  };

  addCuisine = () => {
    const { cuisines, cuisine, list } = this.state;

    if (!cuisine.toString().trim()) {
      return;
    }

    if (!list.find(c => c.name.toLowerCase() === cuisine.toLowerCase())) {
      NotificationManager.error("For any new cuisines to be added in the list, please make a feature request in Feedback under Account", "Cuisines");
      return;
    }

    if (cuisines.find(c => c.name.toLowerCase() === cuisine.toLowerCase())) {
      NotificationManager.error(cuisine + " is already selected", "Cuisines");
      return;
    }
    cuisines.push({
      name: cuisine,
      selected: true
    });

    const index = list.findIndex(item => item.name.toLowerCase() === cuisine.toLowerCase());
    if (index > -1) {
      list.splice(index, 1);
    }

    this.setState({ cuisines, cuisine: "", list });
  };

  removeCuisine = () => {
    let { cuisines, cuisineToBeRemoved, list } = this.state;

    let filterd = cuisines.filter((value, index, arr) => {
      return value.name !== cuisineToBeRemoved;
    });

    list.push({
      name: cuisineToBeRemoved,
      selected: false
    });
    this.setState({ cuisines: filterd, cuisine: "", list, cuisineToBeRemoved: "" });
  };

  handleChange = value => {
    this.setState({ cuisine: value });
  };

  handleError = () =>{
    NotificationManager.error( "Cuisine is required ", "Cuisines");
    return;
  };

  componentDidUpdate(prevProps) {
    if (prevProps.selected.length != this.props.selected.length) {
      this.setState({
        cuisines: this.props.selected
          ? this.props.selected.map(item => {
              return { name: item, selected: true };
            })
          : []
      });
    }
  }

  render() {
    let selected = [];
    this.state.cuisines.map(cuisine => {
      if (cuisine.selected) {
        selected.push(cuisine.name);
      }
    });

    return (
      <div className="chef-right-col">
        <div className="header-step-col cuisines-col">
          <p className="located-text w-60" style={style.headerText}>
            What kind of cuisines are you listing?
          </p>
          <div className="cont-btn">
            <DinerButton />
          </div>
        </div>
        <Grid container>
          <Grid item>
            {this.state.cuisines.length > 0 && <Grid item xs={12} style={{ marginTop: 10, marginLeft: 10, display: 'flex', alignItems: 'center', position: 'relative' }}>
              <Typography style={{ color: primaryColor, fontSize: 14, fontFamily: 'Poppins' }}>
                To remove, select cuisine and press the selected cuisine.
              </Typography>
            </Grid>}
            <Grid container style={{margin: '25px 0 30px'}}>
              {this.state.cuisines.map((item, index) => (
                <Button
                  // fullWidth
                  key={index + item.name}
                  variant={item.selected ? "contained" : "outlined"}
                  color="primary"
                  style={
                    item.selected
                      ? style.cuisineButtonSelected
                      : style.cuisineButton
                  }
                  disableRipple={true}
                  onClick={() => {
                    this.selectCuisine(index, !item.selected);
                    if (!item.selected) {
                      this.setState({ cuisineToBeRemoved: item.name })
                    } else {
                      this.setState({ cuisineToBeRemoved: "" })
                    }
                  }}
                >
                  {item.name}
                </Button>
              ))}
            </Grid>
          </Grid>
          <Grid container style={{position: 'relative', paddingTop: 10}} direction={'row'}>
            <Grid item>
               <ReactAutocomplete
                  items={this.state.list}
                  shouldItemRender={(item, value) =>
                    item.name.toLowerCase().startsWith(value.toLowerCase()) &&
                    value.length > 0
                  }
                  wrapperStyle={{
                    background: "white",
                    width: "100%"
                  }}
                  getItemValue={item => item.name}
                  renderItem={(item, highlighted) => (
                    <div
                      key={new Date().getMilliseconds() + item.name}
                      style={style.suggenstionBox}
                    >
                      <p style={style.suggestionText}> {item.name}</p>
                    </div>
                  )}
                  value={this.state.cuisine}
                  menuStyle={{
                    zIndex: 100,
                    maxHeight: 100,
                    overflow: "auto",
                    background: "white",
                    position: 'relative',
                    top: 0,
                    left: 0
                  }}
                  onChange={e => this.handleChange(e.target.value)}
                  onSelect={value => this.setState({ cuisine: value })}
                  renderInput={props => {
                    return (
                      <div className="group cuisine-col">
                        <input
                       data-test-id={"entercuis"}

                          className="mat-input"
                          placeholder={"Enter Cuisine"}
                          type="text"
                          {...props}
                          style={{ width: "360px", padding: '10px 10px 10px 0', boxSizing: 'border-box' }}
                        />
                        <span className="highlight" />
                        <span className="bar" />
                      </div>
                    );
                  }}
                />
            </Grid>

            <div className="add-btns">
              <Grid item style={{display: 'flex', alignItems: 'center', position: 'relative'}}>
                <div className="action-btn">
                  {this.state.cuisineToBeRemoved.length <= 0 ? <IconButton
                    data-test-id={"addcuisbtn"}
                    disabled={this.state.cuisine.length <= 0}
                    onClick={() => this.addCuisine()}
                  >
                    <AddCircle color={this.state.cuisine.length <= 0 ? "grey" : "primary"} />
                  </IconButton> :
                  <IconButton data-test-id={"remcuisbtn"}
                    onClick={() => this.removeCuisine()}
                    disabled={this.state.cuisineToBeRemoved.length <= 0}
                  >
                    <RemoveCircle color="primary" />
                  </IconButton>}
                </div>
              </Grid>
            </div>
            {this.state.cuisines.length <= 0 && this.state.cuisine.length > 0 && <Grid item xs={12} style={{ marginTop: 10, marginLeft: 10, display: 'flex', alignItems: 'center', position: 'relative' }}>
              <Typography style={{ color: primaryColor, fontSize: 14, fontFamily: 'Poppins' }}>
                Click on the plus button to add the cuisine.
              </Typography>
            </Grid>}
          </Grid>
          <Grid item md={8} />
          <Grid item md={4} sm={12}>
            <Mutation mutation={UPDATE_CHEF}>
              {updateChef => (
                <Formik
                  initialValues={{
                    cuisines: selected
                  }}
                  enableReinitialize
                  validationSchema={CuisineSchema}
                  onSubmit={selected.length !== 0 ? this.props.onSubmit(updateChef) : () => {this.handleError();} }
                >
                  {({ errors, touched, isSubmitting }) => (
                    <Form>
                      <div style={{ textAlign: "right", marginTop: 25 }}>
                        <Fab
                          data-test-id={"cuissubmit"}
                          id={"cuisine-continue"}
                          variant={"extended"}
                          type="submit"
                          style={this.state.cuisines.length <= 0 ? style.disabledSubmitButton : style.submitButton}
                          disabled={this.state.cuisines.length <= 0 || isSubmitting}
                        >
                          Continue
                        </Fab>
                      </div>
                    </Form>
                  )}
                </Formik>
              )}
            </Mutation>
          </Grid>
        </Grid>
      </div>
  );
  }
}

export default Cuisines;
